module.exports = new __parcel__URL__("bossfight_victory_title.80fabd3f.png").toString();